var newsFlag = true;
function newslettersub(footermail) {
    var subemaildata = document.getElementById(footermail).value.trim();
    var preurl = document.getElementById("preurl").value;
    var refurl = document.getElementById("refurl").value;
    if(footermail=="sidefootermail"){
        //document.getElementById(footermail).style.border = "1px solid #c7c7c7";
    }else{
        document.getElementById(footermail).style.borderColor = "#ccc";
        $("#"+footermail).closest(".form-group").removeClass("error");
    }

    var validate = 1;
    var reEmail = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
    if (subemaildata.trim() == "") {
        $("#"+footermail).closest(".form-group").addClass("error");
        document.getElementById(footermail).focus();
        validate = 0;
        $("#footerresult").removeClass("hide").removeClass("alert-success").addClass("alert-danger");
        $("#footerresult").html(
            "Please Enter Email Id."
        );
    } else if (!subemaildata.match(reEmail)) {
        $("#"+footermail).closest(".form-group").addClass("error");
        document.getElementById(footermail).focus();
        validate = 0;
        $("#footerresult").removeClass("hide").removeClass("alert-success").addClass("alert-danger");
        $("#footerresult").html(
            "Please Enter Valid Email Id."
        );
    } else {
        $("#footerresult").html("");
        $("#footerresult").addClass("hide");
        if (newsFlag) {
            newsFlag = false;
            $("#footerfor").html(
                '<img style="display:inline-block" width="12" src="https://cdn1.myassignmenthelp.store/revamp-assets-version2/page-elements/oval.svg">'
            );
            $.ajax({
                method: "GET",
                url:DOMAIN_NAME+"newsletter-subscription-handler.php",
                data: {
                    email: subemaildata,
                    subtype: "footernewsletter",
                    refurl: refurl,
                    preurl: preurl
                },
                success: function(response) {
                    newsFlag = true;
                    $("#footerfor").html(
                        'Join'
                    );
                    document.getElementById(footermail).value = "";
                    if (response == "0") {
                        $("#footerresult").removeClass("hide").removeClass("alert-success").addClass("alert-danger");
                        $("#footerresult").html(
                            "This Email Id Is Already Registered."
                        );
                    }
                    if (response == "1") {
                        $("#footerresult").removeClass("hide").addClass("alert-success").removeClass("alert-danger");
                        $("#footerresult").html(
                            "Thank You For Newsletter Subscription."
                        );
                    }
                    setTimeout(function() {
                        $("#footerresult").html("");
                        $("#footerresult").addClass("hide");
                    }, 5000);
                }
            });
        }
    }
    return false;
}
window.newslettersub = newslettersub;
